/**
 * Maintenance Page - 施工中頁面
 *
 * 當功能開關中的 maintenance.enabled = true 時顯示
 * 非 Admin 用戶將被轉導至此頁面
 */

import { useEffect } from 'react';
import { useFeatures } from '../hooks/useFeatures';
import { useAuth } from '../contexts/AuthContext';
import './MaintenancePage.css';

const MaintenancePage: React.FC = () => {
  const { maintenanceMessage } = useFeatures();
  const { user } = useAuth();

  // 設置頁面標題
  useEffect(() => {
    document.title = '施工中 - 溫�柔小姊姊｜選物 x 微批發';
  }, []);

  // 預設訊息
  const defaultMessage = '網站正在升級中，請稍後再來。';
  const message = maintenanceMessage || defaultMessage;

  // 管理員可以看到額外資訊
  const isAdmin = user?.role === 'admin' || user?.role === 'super_admin';

  return (
    <div className="maintenance-page">
      <div className="maintenance-page__container">
        {/* 圖示 */}
        <div className="maintenance-page__icon">
          <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="60" cy="60" r="55" stroke="#d4af37" strokeWidth="4" fill="none" />
            <path d="M30 55 L45 55 L45 40" stroke="#d4af37" strokeWidth="4" strokeLinecap="round" />
            <path d="M90 55 L75 55 L75 40" stroke="#d4af37" strokeWidth="4" strokeLinecap="round" />
            <path d="M30 75 L45 75 L45 90" stroke="#d4af37" strokeWidth="4" strokeLinecap="round" />
            <path d="M90 75 L75 75 L75 90" stroke="#d4af37" strokeWidth="4" strokeLinecap="round" />
            <rect x="40" y="45" width="40" height="30" rx="2" fill="#d4af37" opacity="0.3" />
          </svg>
        </div>

        {/* 標題 */}
        <h1 className="maintenance-page__title">施工中</h1>

        {/* 訊息 */}
        <p className="maintenance-page__message">{message}</p>

        {/* 說明文字 */}
        <div className="maintenance-page__info">
          <p>我們正在努力為您帶來更好的體驗</p>
          <p>預計很快就會恢復服務</p>
        </div>

        {/* 聯絡資訊 */}
        <div className="maintenance-page__contact">
          <p>如有疑問，請聯繫我們：</p>
          <a href="mailto:hello@belle-selection.shop" className="maintenance-page__email">
            hello@belle-selection.shop
          </a>
        </div>

        {/* 管理員專用資訊 */}
        {isAdmin && (
          <div className="maintenance-page__admin-info">
            <p>🔒 管理員模式</p>
            <p>您可以看到此頁面是因為維護模式已啟用</p>
            <p>但您仍可正常訪問網站進行測試</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MaintenancePage;
